// extracted by mini-css-extract-plugin
export default {"agentsListControlsFAQItem":"agentsListControlsFAQItem_YOdJn","title":"title_u0Wz1","button":"button_N3l73","icon":"icon_baM7o"};